import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { getAllCartItems } from "./addToCart";

const initialState = {
    isLoading: false,
    error: null,
};

const initiaterazorpaySlice = createSlice({
    name: "initiaterazorpay",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
            state.error = null;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const { startLoading, hasError } = initiaterazorpaySlice.actions;

export default initiaterazorpaySlice.reducer;

// ✅ Updated initiateRazorpayPayment to accept full cartItem payload
export const initiateRazorpayPayment = (cartItem, toast, navigate) => async (dispatch) => {
    try {
        dispatch(startLoading());

        const response = await axios.post("/order/create", cartItem);
        const paymentData = response?.data?.data;

        if (paymentData) {
            const amountInPaise = Math.round(parseFloat(paymentData.amount) * 100);

            const options = {
                key: 'rzp_test_QNe8fqdv0T5zOH',
                amount: amountInPaise,
                currency: paymentData.currency || 'INR',
                name: 'Your Company Name',
                description: 'Order Payment',
                order_id: paymentData.razorpay_order_id,

                handler: function (response) {
                    axios.post('/order/payment-success', {
                        razorpay_order_id: paymentData.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                    })
                    .then((res) => {
                        if (res.data.status === true) {
                            toast.success('Payment verified successfully');
                            navigate(`/order-confirmation/${paymentData.order_id}`);
                            window.scrollTo({ top: 0, behavior: 'smooth' });

                            const cart_id = localStorage.getItem('cart_id');
                            const user = JSON.parse(localStorage.getItem('user'));
                            const customer_id = user?.id;
                            const token = localStorage.getItem('accessToken');

                            const payload = { status: !!token };
                            dispatch(getAllCartItems(token ? customer_id : cart_id, payload));
                        } else {
                            toast.error('Payment Verification Failed');
                        }
                    })
                    .catch((error) => {
                        toast.error('Payment Verification Error');
                        console.error('Payment verification error:', error);
                    });
                },

                theme: {
                    color: '#00A762',
                },
            };

            const paymentObject = new window.Razorpay(options);

            paymentObject.on('payment.failed', function (response) {
                axios.post('/order/payment-failed', {
                    razorpay_order_id: response.error.metadata.order_id,
                    razorpay_payment_id: response.error.metadata.payment_id,
                    error_description: response.error.description,
                })
                .then(() => {
                    toast.error('Payment Failed');
                })
                .catch((error) => {
                    toast.error('Error handling payment failure');
                    console.error('Payment failure error:', error);
                });
            });

            paymentObject.open();
        }
    } catch (error) {
        console.error("Error initiating payment:", error);
        toast.error("Refresh the page and try again later.");
        dispatch(hasError(error));
    }
};

